module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/communication/contact-1-c594a4f350f5c33be548fb52034d55ea.svg";